
const path = window.location.pathname
$(document).ready(function(){

  (function() {
    const modalLocation = $('#modal-location')
    const location = localStorage.getItem('location');
    const selectLocationDetail = $('#select-location-detail-product')
    initSelectLocation()
    if ($('#select-location-cart')) populateInventoryData('#select-location-cart')
    if ($('#radio-location-cart')) populateAddressRadio('#radio-location-cart')

    // if(!localStorage.getItem('location')) $("#radio-location-cart input:radio[name='location_id']:first").attr('checked', true)
    if( typeof(locationId) !== "undefined" && locationId) $(`#radio-location-cart input:radio[id='${locationId['Pickup-Location-Id']}']`).attr('checked', true)
    // if(selectLocationDetail) populateInventoryData('#select-location-detail-product')
    // if(location) {
    //   if(path.includes('products')) appendStocksToProduct()
    //   return
    // };
  
    // modalLocation.addClass('show')
    // modalLocation.removeClass('hide')
    populateInventoryData('#select-location')
    
    
  }())

  function appendStocksToProduct() {
      let location = localStorage.getItem('location');
          location = JSON.parse(location)
      const inputProductQty = $('#input-qty');
      let productId = $('#product-input-qty');
          productId = productId.attr('data-product-id')
      let date = new Date(); 
          date.setDate(date.getDate() + 1);
          date = date.toISOString().slice(0,10);
    
      checkStocks(location.id, [productId],date, function(data) {
        const elQty = $('#product-qty')
        const payload = data.data;
        const available = payload[0].available

        elQty.text(available)
        if (available <= 0) {
          inputProductQty.prop('disabled', true);
          inputProductQty.attr('value', 0)
          $('#btn-plus').hide()
          $('#btn-min').hide()
          $('.add-to-cart-btn-qty').hide()
          return;
        }
          $('#btn-plus').show()
          $('#btn-min').show()
          $('.add-to-cart-btn-qty').show()
          inputProductQty.attr('max', available)
      })
  }
  
  function populateInventoryData(id) {
      const select = $(id);
      let locationDefault = localStorage.getItem('location');
          locationDefault = locationDefault ? JSON.parse(locationDefault) : {}
      $.each(locations, function(index, location) {
        const value = location.id;
        const selected = (locationDefault.id === value)
        const text = location.name;
        const address = location.address1;
        const option = `<option value="${value}"><span class="text-extrabold">${text}</span> ${address}</option>`
        const optionElement = $(option);
        select.append(optionElement);
      });
      select.val(locationDefault.id)
  }

  // BEGIN DEV
  function populateAddressRadio(id) {
      const select = $(id);
      let locationDefault = localStorage.getItem('location');
          locationDefault = locationDefault ? JSON.parse(locationDefault) : {}
      $.each(locations, function(index, location) {
        const value = location.id;
        const checked = (locationDefault.id === value) ? 'checked' : '';
        const text = location.name;
        const address = location.address1;
        const city = location.city;
        const zip = location.zip;
        const option = `<div id="loc-${value}" tabindex="0" class="location clearfix" onClick=chooseLocation(this.id)>
                          <input id="${value}" name="location_id" type="radio" ${checked} aria-label="${text}" class="locationRadio" value="${value}">
                          <span class="block">
                            <span class="&quot;name&quot;">
                              <strong>${text}</strong>
                            </span>
                            <span class="&quot;address&quot;">${address} <br>${city}, ${zip} </span>
                            <span class="&quot;distance&quot;"></span>
                          </span>
                        </div>`;
        
        const optionElement = $(option);
        select.append(optionElement);
      });
      select.val(locationDefault.id)
  }
  // END DEV
  
  function initSelectLocation() {
      const wrappers = $('.select-location-custom');
      let locationDefault = localStorage.getItem('location');
          locationDefault = locationDefault ? JSON.parse(locationDefault) : {}
      for (let wrapper of wrappers) {
        wrapper = $(wrapper)
        let triggerVal = wrapper.find('span.dropdown-value');
            triggerVal = $(triggerVal)
        let select = wrapper.find('ul');
            select = $(select)
        
        $.each(locations, function(index, location) {
          const value = location.id;
          const text = location.name;
          const address = location.address1;

          const option = `<li data-location-id="${value}" class="text-gray-900 select-location-option relative cursor-default text-md hover:bg-gray-200 select-none py-2 pl-3 pr-9 font-bold" role="option">${text}<span class="!font-light block">${address}</span> </li>`
          const optionElement = $(option);
          if(locationDefault.id === value) triggerVal.empty().append(`${text}`)
          select.append(optionElement);
        });
     
      }

  }

  $('.select-location-option').on('click', function(e) {
    e.preventDefault();
    const option = $(this);
    const value = option.attr('data-location-id')
    const location = searchLocationData(value)
    const ul = $(option.parent())
    const spanOption = $('span.dropdown-value')
    localStorage.setItem('location', JSON.stringify(location));
    if(path.includes('products')) appendStocksToProduct()
    ul.removeClass('visible')
    ul.addClass('invisible')
    spanOption.empty().append(`${location.name}`)
  })
  
  $('.select-location').on('change', function(e) {
    const value = e.target.value
    const location = searchLocationData(value)
    
    localStorage.setItem('location', JSON.stringify(location));
    if(path.includes('products')) appendStocksToProduct()

  })

  $('#choose-location').on('click', function(e) {
    const modalLocation = $('#modal-location')
    let location = localStorage.getItem('location');
        location = location ? JSON.parse(location) : {}
    modalLocation.removeClass('show')
    modalLocation.addClass('hide')
     $.ajax({
      type: 'POST', 
      url: '/cart/update.js',
      dataType: 'json', 
      data: {
        "attributes": {
          "Pickup-Location-Id": location.id,
          "Pickup-Location-Company": location.name,
          "Pickup-Location-Address-Line-1": location.address1,
          "Pickup-Location-City": location.city,
          "Pickup-Location-Region": location.localized_country_name,
          "Pickup-Location-Postal-Code": location.zip,
          "Pickup-Location-Country": location.localized_country_name,
          "Pickup-Location-Province": location.localized_province_name,
          "Checkout-Method": "pickup",
        }
      },
      success: function(data) {
        console.log($('#select-location-detail-product').val())
        if($('#select-location-detail-product').val() === null) {
          $('#select-location-detail-product').val(location.id)
        }
      }
      
   });      
  })

  $('.select-custom-trigger').on('click', function(e) {
    e.preventDefault();
    let trigger =$(this);
    const dropdown = trigger.siblings('ul')
        
    if(dropdown.hasClass('invisible')){
      dropdown.removeClass('invisible');
      dropdown.addClass('visible')
      return
    }
    dropdown.addClass('invisible');
    dropdown.removeClass('visible')
  })

  function searchLocationData(id) {
    for (let location of locations) {
      if(location.id === id) return location
    }
  }

  function checkStocks(locationId, productIds, date, callback) {
    const ids = productIds.toString()
    const url = `https://dm.marukaicorp.com/api/getproductsstock?pickupdate=${date}&location=${locationId}&ids=${ids}`
    const data = {}
    $.ajax({
      url: url,
      headers: {
        'Authorization': "Bearer 4YFVn74PqVw3Suz7oMsFb17zWwgVFlYfvLh9SOOh=Djwjk2=3oSfWzEk?PC8xYAQ0Fsb=uLxw!A=kF9iNJws4pIPn44UdVf!DsFImsRev96Q!scoYSRGDrqO10Oc!VdufcBi32IVjpLk/jK3MGDz=/Og9lKUgULSfu6K36v2ExjiEzVyMo-11xtfs0tgaq5o5=SQgZwTlhBZ=XsONNT0A?fKfYmoF-FhiHlfNblRj7So?G5uaZZs8jLnqSpw7Zv2"
      }
    }).done(function(data) {
      callback(data)
    });
  }
})